import Axios from 'axios';
import i18next from 'i18next';

import {
	CLEAR_SELF_SETTINGS_ERRORS,
	SELF_SETTING_CREATE_LOADING,
	SELF_SETTING_CREATE_ERROR,
	ALL_SELF_SETTINGS_LOADING,
	ALL_SELF_SETTINGS_GET,
	ALL_SELF_SETTINGS_ERROR,
	SELF_SETTING_UPDATE_LOADING,
	SELF_SETTING_UPDATE_ERROR,
	SELF_SETTING_DELETE_LOADING
} from '../types';

// Utils
import create_query_params from '../../utils/create_query_params';
import add_key_prop from '../../utils/add_key_prop';

export const clear_self_settings_errors = () => dispatch => {
	dispatch({
		type: CLEAR_SELF_SETTINGS_ERRORS
	});
}

export const self_setting_create = (messageApi, selfSettingBody, handleCancel, filters) => dispatch => {
	dispatch({
		type: SELF_SETTING_CREATE_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + '/api/self/settings/create';

	Axios.post(url, selfSettingBody)
	.then((res) => {
		messageApi.success(i18next.t('settingsForm.create.msg.success'), 4);

		handleCancel();

		dispatch({
			type: SELF_SETTING_CREATE_LOADING,
			payload: false
		});

		dispatch(get_all_self_settings(filters));
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: SELF_SETTING_CREATE_ERROR,
			payload: { type: 'self_setting_create', msg: err.message }
		});

		dispatch({
			type: SELF_SETTING_CREATE_LOADING,
			payload: false
		});
	})
}

export const get_all_self_settings = (filters) => dispatch => {
	dispatch({
		type: ALL_SELF_SETTINGS_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + '/api/self/settings?';
	let query = create_query_params(filters);
	url += query;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data);
		const newSettingsArray = add_key_prop(res.data.data);
		res.data.settings = newSettingsArray;

		dispatch({
			type: ALL_SELF_SETTINGS_GET,
			payload: res.data
		});

		dispatch({
			type: ALL_SELF_SETTINGS_LOADING,
			payload: false
		});
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: ALL_SELF_SETTINGS_ERROR,
			payload: { type: 'all_self_settings', msg: err.message }
		});

		dispatch({
			type: ALL_SELF_SETTINGS_LOADING,
			payload: false
		});
	})
}

export const self_setting_update = (messageApi, selfSettingId, selfSettingBody, handleCancel, filters) => dispatch => {
	dispatch({
		type: SELF_SETTING_UPDATE_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + `/api/self/settings/${selfSettingId}/update`;

	Axios.put(url, selfSettingBody)
	.then((res) => {
		messageApi.success(i18next.t('settingsForm.edit.msg.success'), 4);
		
		handleCancel();

		dispatch({
			type: SELF_SETTING_UPDATE_LOADING,
			payload: false
		});

		dispatch(get_all_self_settings(filters));
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: SELF_SETTING_UPDATE_ERROR,
			payload: { type: 'self_setting_update', msg: err.message }
		});

		dispatch({
			type: SELF_SETTING_UPDATE_LOADING,
			payload: false
		});
	})
}

export const self_setting_delete = (messageApi, selfSettingId, filters) => dispatch => {
	dispatch({
		type: SELF_SETTING_DELETE_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + `/api/self/settings/${selfSettingId}/remove`;

	Axios.delete(url)
	.then((res) => {
		messageApi.success(i18next.t('settingsForm.delete.msg.success'), 4);

		dispatch({
			type: SELF_SETTING_DELETE_LOADING,
			payload: false
		});

		dispatch(get_all_self_settings(filters));
	}).catch((err) => {
		// console.log(err);
		messageApi.error(i18next.t('settingsForm.delete.msg.error'), 4);

		dispatch({
			type: SELF_SETTING_DELETE_LOADING,
			payload: false
		});
	})
}
